import { LabelSummary } from '@/analysis/types';
import { QueryResult } from '@/type';
import api from '@/API';

interface LabelFilters {
  keyword?: string;
  offset?: number;
  limit?: number;
}

export default {
  findAll(clientId: number, filters: LabelFilters = {}): Promise<QueryResult<LabelSummary>> {
    return api
      .get(`clients/${clientId}/labels`, { params: filters })
      .then(response => response.data);
  },
};
